var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zx-tag",class:[`zx-tag__${_vm.size}`],style:({'--color': _vm.color, '--bgcolor': _vm.bgColor, '--borcolor': _vm.borColor})},[_vm._t("default",function(){return [_vm._v("标签")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }